/*
 * SMParts — Suchleiste am Rechner mit grossem Suchfenster
 *
 * Antippen oeffnet das Fenster unter dem Feld und dunkelt die Seite ab.
 * Leer zeigt es, was der Server schon gerendert hat (Aktion, beliebte
 * Begriffe, beliebte Produkte). Beim Tippen holt es Treffer ueber
 * Shopifys /search/suggest.json und zeichnet Vorschlaege und Produkte.
 *
 * Enter schickt das Formular ab wie immer — zur vollen Suchseite.
 * Escape, ein Klick auf den Schleier oder Fokus ausserhalb schliessen.
 */
(function () {
  'use strict';

  if (customElements.get('smp-kopfsuche')) return;

  var WARTEN = 220;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Wie das Geldformat des Shops ("€1.000,00"), damit die Preise im
     Leerzustand (vom Server) und in den Treffern (von hier) gleich
     aussehen. Andere Waehrungen ueber Intl. */
  function geld(betrag) {
    var zahl = parseFloat(betrag);
    if (isNaN(zahl)) return '';
    var waehrung = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var ziffern = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(zahl);
    if (waehrung === 'EUR') return '€' + ziffern;
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: waehrung }).format(zahl);
    } catch (e) {
      return ziffern + ' ' + waehrung;
    }
  }

  function bildUrl(url, breite) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + breite;
  }

  class SmpKopfsuche extends HTMLElement {
    connectedCallback() {
      if (this.bereit) return;
      this.bereit = true;

      this.feld = this.querySelector('[data-smp-ks-feld]');
      this.fenster = this.querySelector('[data-smp-ks-fenster]');
      this.schleier = this.querySelector('[data-smp-ks-schleier]');
      this.leer = this.querySelector('[data-smp-ks-leer]');
      this.treffer = this.querySelector('[data-smp-ks-treffer]');
      this.vorschlaege = this.querySelector('[data-smp-ks-vorschlaege]');
      this.produkte = this.querySelector('[data-smp-ks-produkte]');
      this.nichts = this.querySelector('[data-smp-ks-nichts]');
      this.alle = this.querySelector('[data-smp-ks-alle]');
      this.alleText = this.querySelector('[data-smp-ks-alle-text]');
      this.leeren = this.querySelector('[data-smp-ks-leeren]');
      this.zurueck = this.querySelector('[data-smp-ks-zurueck]');
      this.alleOben = this.querySelector('[data-smp-ks-alle-oben]');
      this.mobil = window.matchMedia('(max-width: 989px)');
      this.anzahl = parseInt(this.dataset.anzahl, 10) || 5;
      this.zwischen = {};
      this.timer = null;
      this.abbruch = null;
      this.wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      if (!this.feld || !this.fenster) return;

      var self = this;
      this.feld.addEventListener('focus', function () {
        self.auf();
      });
      this.feld.addEventListener('click', function () {
        self.auf();
      });
      this.feld.addEventListener('input', function () {
        self.eingabe();
      });
      this.feld.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          self.zu();
          self.feld.blur();
        }
      });
      this.schleier.addEventListener('click', function () {
        self.zu();
      });
      this.zurueck.addEventListener('click', function () {
        self.zu();
      });

      /*
        Mobil: die Lupe im Header oeffnet diese Suche als Vollbild statt
        Dawns Suchfenster. Abgefangen in der Capture-Phase, bevor Dawns
        <details-modal> den Klick bekommt.
      */
      document.addEventListener(
        'click',
        function (e) {
          if (!self.mobil.matches) return;
          var lupe = e.target.closest && e.target.closest('.header__icon--search');
          if (!lupe) return;
          e.preventDefault();
          e.stopPropagation();
          self.auf();
          self.feld.focus();
        },
        true
      );

      this.leeren.addEventListener('click', function () {
        self.feld.value = '';
        self.eingabe();
        self.feld.focus();
      });
      /* Am Rechner schliesst Fokus ausserhalb; mobil nicht — dort
         verliert das Feld den Fokus schon, wenn die Tastatur zugeht. */
      this.addEventListener('focusout', function () {
        if (self.mobil.matches) return;
        window.setTimeout(function () {
          if (!self.contains(document.activeElement)) self.zu();
        }, 0);
      });
      document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape' && self.offen) self.zu();
      });

      if (this.feld.value.trim()) this.leeren.hidden = false;
    }

    auf() {
      if (this.offen) return;
      this.offen = true;
      this.fenster.hidden = false;
      this.schleier.hidden = false;
      this.classList.add('smp-kopfsuche--offen');
      this.feld.setAttribute('aria-expanded', 'true');
      document.body.classList.add('smp-suche-offen');
      if (this.mobil.matches) document.body.classList.add('smp-suche-vollbild');
      if (this.feld.value.trim()) this.eingabe();
    }

    zu() {
      if (!this.offen) return;
      this.offen = false;
      this.fenster.hidden = true;
      this.schleier.hidden = true;
      this.classList.remove('smp-kopfsuche--offen');
      this.feld.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('smp-suche-offen', 'smp-suche-vollbild');
    }

    eingabe() {
      var q = this.feld.value.trim();
      this.leeren.hidden = !q;
      window.clearTimeout(this.timer);

      if (!q) {
        this.leer.hidden = false;
        this.treffer.hidden = true;
        return;
      }
      if (!this.offen) this.auf();

      var self = this;
      this.timer = window.setTimeout(function () {
        self.holen(q);
      }, WARTEN);
    }

    holen(q) {
      var self = this;
      if (this.zwischen[q]) {
        this.zeichnen(q, this.zwischen[q]);
        return;
      }
      if (this.abbruch) this.abbruch.abort();
      this.abbruch = new AbortController();

      var url =
        this.wurzel +
        'search/suggest.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product,query' +
        '&resources[limit]=' + this.anzahl +
        '&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last';

      this.classList.add('smp-kopfsuche--laedt');
      fetch(url, { signal: this.abbruch.signal })
        .then(function (r) {
          return r.json();
        })
        .then(function (daten) {
          var res = (daten && daten.resources && daten.resources.results) || {};
          self.zwischen[q] = res;
          if (self.feld.value.trim() === q) self.zeichnen(q, res);
        })
        .catch(function () {})
        .finally(function () {
          self.classList.remove('smp-kopfsuche--laedt');
        });
    }

    zeichnen(q, res) {
      /* Interne Produkte (Upcarts Shipping Protection) nicht vorschlagen. */
      var produkte = (res.products || []).filter(function (p) {
        return !/shipping protection/i.test((p.type || '') + ' ' + (p.title || ''));
      });
      var anfragen = res.queries || [];

      /* Vorschlaege: Shopifys Suchanfragen, sonst die Begriffe aus dem
         Leerzustand, die zum Getippten passen, sonst alle. */
      var begriffe = anfragen.map(function (a) {
        return { text: a.text, html: a.styled_text || esc(a.text) };
      });
      if (!begriffe.length) {
        var alle = Array.prototype.map.call(
          this.leer.querySelectorAll('.smp-ks-begriffe a'),
          function (a) {
            return a.textContent.trim();
          }
        );
        var passend = alle.filter(function (b) {
          return b.toLowerCase().indexOf(q.toLowerCase()) > -1;
        });
        begriffe = (passend.length ? passend : alle).map(function (b) {
          return { text: b, html: esc(b) };
        });
      }

      var suche = this.wurzel + 'search?type=product&options%5Bprefix%5D=last&q=';
      this.vorschlaege.innerHTML = begriffe
        .slice(0, 6)
        .map(function (b) {
          return '<li><a href="' + suche + encodeURIComponent(b.text) + '">' + b.html + '</a></li>';
        })
        .join('');

      this.produkte.innerHTML = produkte
        .map(function (p) {
          var alt = parseFloat(p.compare_at_price_max);
          var neu = parseFloat(p.price);
          var sale = alt > neu;
          var rabatt = sale ? Math.round(((alt - neu) / alt) * 100) : 0;
          var bild = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          return (
            '<li><a class="smp-ks-produkt" href="' + esc(p.url) + '">' +
            '<span class="smp-ks-produkt__bild">' +
            (bild ? '<img src="' + esc(bildUrl(bild, 180)) + '" width="90" height="90" alt="" loading="lazy">' : '') +
            '</span>' +
            '<span class="smp-ks-produkt__text">' +
            '<span class="smp-ks-produkt__titel">' + esc(p.title) + '</span>' +
            '<span class="smp-ks-produkt__preise">' +
            (sale ? '<s class="smp-ks-produkt__alt">' + geld(alt) + '</s>' : '') +
            '<span class="smp-ks-produkt__preis' + (sale ? ' smp-ks-produkt__preis--sale' : '') + '">' + geld(neu) + '</span>' +
            (sale ? '<span class="smp-ks-produkt__rabatt">-' + rabatt + '%</span>' : '') +
            '</span></span></a></li>'
          );
        })
        .join('');

      this.nichts.hidden = produkte.length > 0;
      this.nichts.textContent = produkte.length ? '' : 'Keine Produkte für „' + q + '“ gefunden.';

      this.alle.setAttribute('href', suche + encodeURIComponent(q));
      if (this.alleOben) this.alleOben.setAttribute('href', suche + encodeURIComponent(q));
      this.alleText.textContent = 'Zu allen Ergebnissen für „' + q + '“';

      this.leer.hidden = true;
      this.treffer.hidden = false;
    }
  }

  customElements.define('smp-kopfsuche', SmpKopfsuche);
})();
